import { Microphone, Waveform } from "@phosphor-icons/react";

export interface AudioInputStatus {
  isGenerating: boolean;
  isTranscribing: boolean;
  isListening: boolean;
  isSpeechSupported: boolean;
}

interface VoiceInputButtonsProps {
  audio: AudioInputStatus;
  audioInputRef: React.RefObject<HTMLInputElement | null>;
  onAudioUpload: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onToggleSpeech: () => void;
}

export function VoiceInputButtons({
  audio,
  audioInputRef,
  onAudioUpload,
  onToggleSpeech,
}: VoiceInputButtonsProps) {
  const { isGenerating, isTranscribing, isListening, isSpeechSupported } =
    audio;
  return (
    <div className="absolute bottom-2 right-2 flex items-center gap-[10px]">
      <button
        type="button"
        onClick={() => audioInputRef.current?.click()}
        disabled={isGenerating || isTranscribing || isListening}
        className={`btn-voice-input text-[var(--text-primary)] transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--accent-primary)] focus-visible:ring-offset-2 ${isTranscribing ? "animate-pulse" : ""}`}
        aria-label="Upload voice memo"
        title="Upload voice memo"
      >
        <Waveform size={16} weight={isTranscribing ? "fill" : "regular"} />
      </button>
      <input
        ref={audioInputRef}
        type="file"
        accept=".mp3,.wav,.m4a,.webm,.ogg,.opus,.aac"
        onChange={onAudioUpload}
        className="hidden"
        disabled={isGenerating || isTranscribing || isListening}
      />
      {isSpeechSupported ? (
        <button
          type="button"
          onClick={onToggleSpeech}
          disabled={isGenerating || isTranscribing}
          className={`btn-voice-input text-[var(--text-primary)] transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--accent-primary)] focus-visible:ring-offset-2 ${isListening ? "animate-pulse" : ""}`}
          aria-label={isListening ? "Stop recording" : "Start voice input"}
          title={isListening ? "Stop recording" : "Start voice input"}
        >
          <Microphone size={16} weight={isListening ? "fill" : "regular"} />
        </button>
      ) : (
        <button
          type="button"
          disabled
          className="btn-voice-input text-[var(--text-secondary)]"
          aria-label="Voice input not supported"
          title="Voice input not supported in this browser"
        >
          <Microphone size={16} />
        </button>
      )}
    </div>
  );
}
